/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import Examen from './Examen';
import {bindActionCreators} from 'redux';
import * as tagActions from '../../actions/tagActions';
import * as formularioActions from '../../actions/formularioActions';
import * as resultadoexamenActions from '../../actions/resultadoexamenActions';
import * as comentariosActions from '../../actions/comentariosActions';

import toastr from 'toastr';
import ManageList from '../common/ManageList';

import { Segment, Header} from 'semantic-ui-react';
import ModalSiNo from '../common/ModalSiNo';
import $ from 'jquery';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import * as cursoActions from '../../actions/cursoActions';
import * as Resultado from '../common/Resultado';

import * as userActions from '../../actions/userActions';
import * as paginaActions from '../../actions/paginaActions';
import * as infoActions from '../../actions/infoActions';

import {getMargenes} from '../../util/';
import moment from 'moment';

class ManageExamen extends React.Component {
    constructor(props, context) {
		
		super(props, context);
        
      
        this.state={
            errors:{},
            strings:{},
            curso:{
                 modulos:[]
             },
            showActivos:true,
            showModal:false,
            filtrosCombo:{},
            permisos:{},
            errores:[],
            appLocale:{
                "singleSelectionTagText":"Seleccion simple",    
                "multipleSelectionTagText":"Selección multiple",  
                "pickNumberOfSelection":"Selecciona <numberOfSelection>",
                "resultPagePoint": "Obtuviste <correctPoints> de un total de <totalPoints>.",
                "landingHeaderText": "La siguiente prueba consta de <questionLength> Preguntas",
                "question": "Pregunta",
                "startQuizBtn": "Comenzar prueba",
                "resultFilterAll": "All",
                "resultFilterCorrect": "Correct",
                "resultFilterIncorrect": "Incorrect",
                "nextQuestionBtn": "Siguiente",
                "resultPageHeaderText": "Tu has completado la prueba. Tuviste <correctIndexLength> correctas de <questionLength> preguntas."
                } ,
            quiz: null,
            visible:true, 
            fechaActual: new moment()
            
		};
	}

	componentDidMount(){
        
     
        this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);
        this.props.showSidebarIzquierdaActions.onShowSidebarIzquierda(false);
        this.cargarExamen(this.props.idForm);
        
        
        /*
        this.props.formularioActions.getExamen(this.props.idForm, this.props.user).then( examen=>{
             let errores = this.state.errores;
            //console.log(examen.id);
                if(examen.id>0){
                    for(let i=0; i<examen.questions.length; i++){
                        if(examen.questions[i].answerSelectionType=="single"){
                                if(examen.questions[i].correctAnswer[0]){
                                    examen.questions[i].correctAnswer = examen.questions[i].correctAnswer[0].toString();
                                }else{
                                    errores.push(examen.questions[i]);
                                }    
                        }else{
                            if(examen.questions[i].correctAnswer.length==0){
                                
                                errores.push(examen.questions[i]);
                                
                            }
                        }

                    }
                }    
                this.setState({"quiz":examen, "errores": errores});
                 })
                .catch(error=>{
                  toastr.error(error);
            });
         */
        
	}
    
    
    
    cargarExamen=(id)=>{
        
           this.props.formularioActions.getExamen(id, 0, this.props.user).then( examen=>{

                 let errores = this.state.errores;
                if(examen.id>0){
                     examen.appLocale = this.state.appLocale;
                    for(let i=0; i<examen.questions.length; i++){
                        if(examen.questions[i].answerSelectionType=="single"){
                                if(examen.questions[i].correctAnswer[0]){
                                    examen.questions[i].correctAnswer = examen.questions[i].correctAnswer[0].toString();
                                }else{
                                    errores.push(examen.questions[i]);
                                }    
                        }else{
                            if(examen.questions[i].correctAnswer.length==0){
                                
                                errores.push(examen.questions[i]);
                                
                            }
                        }

                    }
                   
                }    
               
                
               
                this.setState({"quiz":examen, "errores": errores});
                 })
                .catch(error=>{
                  toastr.error(error);
            });
        
       
    }

  
  setQuizResult = (obj) => {
      //console.log(obj);
      
        /*
      if(obj.totalPoints>0){
        obj.fullExam = Object.assign({},JSON.stringify(obj));
        obj.idFormulario = this.state.idFormulario;
        obj.idModuloContenido = this.state.idModuloContenido;
        obj.idCurso = this.state.curso.id;
        
          this.props.resultadoexamenActions.save(obj, this.props.user).then(() => {
            toastr.success("Registro guardado!!!.");
        });
      }
      */
  
  }
  
  
  renderCustomResultPage = (obj) => {
    //console.log(obj);
      let quiz = this.state.quiz;
      
      return (
        <Segment >
            <Header as='h3'>{quiz.quizTitle}</Header>
            
            Total de preguntas:{obj.numberOfQuestions}<br/>
            Correctas:{obj.numberOfCorrectAnswers}<br/>
            Incorrectas:{obj.numberOfIncorrectAnswers}<br/>
            Total de puntos posibles:{obj.totalPoints}<br/>
            Total obtenido:{obj.correctPoints}<br/>
            
        
        
        </Segment>    
      
      )

  }

  

    
    render() {
        let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		return (
            <Segment   style={margenes}>
                 
                <Examen
                   
                    strings={this.props.strings}
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    id={this.state.id}
                    quiz={this.state.quiz}
                    setQuizResult={this.setQuizResult}
                    renderCustomResultPage={this.renderCustomResultPage}
                    errores={this.state.errores}
                />
            
             

            </Segment> 
            
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps){
    return {
          

        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda,
        ajaxCallInProgress:state.ajaxCallInProgress,
        color:state.color,
        form:state.form,
        color:state.color,
        strings:state.strings,
        idioma:state.idioma,
        user:state.user
    }

}


function mapDispatchToProps(dispatch){

	return { 
        paginaActions: bindActionCreators(paginaActions, dispatch),
        infoActions: bindActionCreators(infoActions, dispatch),
        cursoActions: bindActionCreators(cursoActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch),
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
        formularioActions: bindActionCreators(formularioActions, dispatch),
        resultadoexamenActions: bindActionCreators(resultadoexamenActions, dispatch),
        comentariosActions: bindActionCreators(comentariosActions, dispatch)
 	};
}


export default connect (mapStateToProps, mapDispatchToProps)(ManageExamen);